import * as React from 'react';
export function useScrollable() {
    const [scrollable, setScrollable] = React.useState(false);
    const cleanupRef = React.useRef(undefined);
    const scrollRef = React.useCallback((el) => {
        cleanupRef.current?.();
        cleanupRef.current = undefined;
        if (!el) {
            setScrollable(false);
            return;
        }
        const update = () => setScrollable(el.scrollHeight > el.clientHeight + 1);
        const resizeObserver = new ResizeObserver(update);
        const observeChildren = () => {
            resizeObserver.disconnect();
            resizeObserver.observe(el);
            for (const child of Array.from(el.children)) {
                resizeObserver.observe(child);
            }
            update();
        };
        const mutationObserver = new MutationObserver(observeChildren);
        observeChildren();
        mutationObserver.observe(el, { childList: true });
        cleanupRef.current = () => {
            resizeObserver.disconnect();
            mutationObserver.disconnect();
        };
    }, []);
    return { scrollable, scrollRef };
}
